import { render } from "./DealerCreditProfileTabs.vue?vue&type=template&id=b0650946&scoped=true&ts=true"
import script from "./DealerCreditProfileTabs.vue?vue&type=script&lang=ts"
export * from "./DealerCreditProfileTabs.vue?vue&type=script&lang=ts"

import "./DealerCreditProfileTabs.vue?vue&type=style&index=0&id=b0650946&scoped=true&lang=scss"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0650946"]])

export default __exports__